import { render, staticRenderFns } from "./ListarDocumentos.vue?vue&type=template&id=8b663380&scoped=true"
import script from "./ListarDocumentos.vue?vue&type=script&lang=js"
export * from "./ListarDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ListarDocumentos.vue?vue&type=style&index=0&id=8b663380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b663380",
  null
  
)

export default component.exports